import React, { Suspense, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initApplication } from './slice'
import agent from '../../api/agent'
import { memo } from 'react'
import { clearRedirect } from '../../reducers/common'
import { useNavigate } from 'react-router'
import SignIn from '../admin-user/sign-in/SignIn'
import ForgotPassword from '../admin-user/forgot-password/ForgotPassword'
import ProtectedRoute from '../common/ProtectedRoute'
import Dashboard from '../dashboard/Dashboard'
import UserSettings from '../admin-user/settings/UserSettings'
import UserGeneralSettings from '../admin-user/settings/general/UserGeneralSettings'
import SecuritySettings from '../admin-user/settings/security/SecuritySettings'
import Meetings from '../meetings/Meetings'
import MeetingList from '../meetings/list/MeetingList'
import MeetingTypes from '../meetings/types/MeetingTypes'
import Users from '../users/Users'
import TypeDetails from '../meetings/types/details/TypeDetails'

function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const redirectTo = useSelector((state) => state.common.redirectTo)
  const appLoaded = useSelector((state) => state.common.appLoaded)

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo)
      dispatch(clearRedirect())
    }
  }, [redirectTo])

  useEffect(() => {
    const token = window.localStorage.getItem('admin-api-token')
    agent.setApiToken(token)
    dispatch(initApplication())
  }, [])

  if (appLoaded) {
    return (
      <>
        <Suspense fallback={<p>Loading...</p>}>
          <Routes>
            <Route exact path="/sign-in" element={<SignIn />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
            <Route
              exact
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/meetings"
              element={
                <ProtectedRoute>
                  <Meetings />
                </ProtectedRoute>
              }
            >
              <Route exact path="" element={<MeetingList />} />
              <Route exact path="types" element={<MeetingTypes />} />
              <Route exact path="types/:meetingTypeUuid" element={<TypeDetails />} />
            </Route>
            <Route
              exact
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/settings"
              element={
                <ProtectedRoute>
                  <UserSettings />
                </ProtectedRoute>
              }
            >
              <Route exact path="general" element={<UserGeneralSettings />} />
              <Route exact path="security" element={<SecuritySettings />} />
            </Route>
          </Routes>
        </Suspense>
      </>
    )
  } else {
    return <div>Loading</div>
  }
}

export default memo(App)
